(() => {
  if (window.tsProductionNavigationInitialized) return;
  window.tsProductionNavigationInitialized = true;
  // Close the native drawer before following an in-page link, and release its focus trap.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('header-drawer a[href]');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    const toggle = drawer.querySelector(':scope > details');
    if (toggle?.open && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, toggle.querySelector(':scope > summary'));
    }
  });
  if (customElements.get('ts-newsletter-popup')) return;
  customElements.define('ts-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.key = 'todaysunny-newsletter-last-shown-v1';
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-popup-close]') || event.target === this.dialog) this.close();
      }, options);
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')].filter((element) => element.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }, options);
      const formResponse = this.querySelector('[data-popup-success], [data-popup-error]');
      this.editor = this.dataset.designMode === 'true';
      if (this.editor && this.dataset.editorPreview !== 'true') return;
      if (formResponse) {
        if (this.querySelector('[data-popup-success]')) this.remember();
        this.show();
        formResponse.focus();
        return;
      }
      if (!this.editor && this.wasDismissed()) return;
      this.timer = window.setTimeout(() => this.showWhenReady(), this.editor ? 500 : Number(this.dataset.delay || 20) * 1000);
    }
    wasDismissed() {
      try { return Date.now() - Number(localStorage.getItem(this.key) || 0) < Number(this.dataset.frequency || 7) * 86400000; }
      catch (_) { return false; }
    }
    remember() {
      if (this.editor) return;
      try { localStorage.setItem(this.key, String(Date.now())); } catch (_) { /* Storage may be unavailable. */ }
    }
    showWhenReady() {
      const busy = document.hidden || document.querySelector('header-drawer > details[open], details-modal > details[open], cart-drawer.active, modal-dialog[open], dialog[open]');
      if (busy) { this.timer = window.setTimeout(() => this.showWhenReady(), 3000); return; }
      this.show();
    }
    show() {
      if (!this.isConnected || this.dialog.open) return;
      this.returnFocus = document.activeElement;
      this.dialog.showModal();
      this.remember();
    }
    close() { this.remember(); this.dialog.close(); }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
